export enum GlobalSearchItemsType {
  Services = "Services",
  Orders = "Orders",
  Attempts = "Attempts"
}
